import { Box, customStyled } from '@mafc/trolly';
import MQ from 'theme/breakpoints';

export const Payment = customStyled(Box)`
  position: relative;
  margin: 24px 4px;
  color: ${props => props.theme.colors.black}
  ${MQ[1]} {
    margin: 24px 0;
  }
`;

export const SelectPaymentMethod = customStyled(Box)(({ theme: { space, radii, colors } }) => ({
  background: colors.white,
  borderRadius: radii[3],
  padding: `${space[3]}px ${space[4]}px`,
}));
